import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { validationClasses } from '@/utils/errors';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { camelConverter } from '../helper';
import { isFormMultiplesField } from '../state/state';

const listClasses = (error, direction) => {
  const classes = ['aridhia-form-dropdown', 'max-content'];

  if (direction) {
    classes.push(direction);
  }

  return validationClasses(error, classes.join(' '));
};

const listItems = (options, value) => options.map((option) => ({
  key: `request_form_dropdown_item_${option.value}`,
  text: option.text,
  description: option.description,
  value: option.value,
  active: option.value === value,
}));

const FormDropdown = ({
  autoFocus,
  disabled,
  direction,
  error,
  field,
  onChange,
  text,
  upward,
}) => (
  <Dropdown
    autoFocus={autoFocus}
    className={listClasses(error, direction)}
    clearable={!field.validation?.required && !isFormMultiplesField(field.validation)}
    disabled={disabled}
    fluid
    id={camelConverter(field.name, '_')}
    multiple={isFormMultiplesField(field.validation)}
    onChange={(e, { value }) => onChange(hasMinimumLength(value) ? value : null)}
    options={listItems(field.options, isFormMultiplesField(field.validation) ? null : text)}
    placeholder={field.placeholder}
    search
    selection
    upward={upward}
    value={text}
  />
);

export default FormDropdown;
